// extracted by mini-css-extract-plugin
export default {"chip":"Chip_chip__Re67+","text":"Chip_text__aWIXp","icon":"Chip_icon__y5-cy","selectable":"Chip_selectable__dLxla","selected":"Chip_selected__qVHLy"};